// Day ranges shared by the idle repairs chart and table, as the API takes them ("min,max").
// Repairs idle for more than MAX_IDLE_DAYS are left out of the dashboard (IdleRepairsQuery::MAX_IDLE_DAYS)
export const MAX_IDLE_DAYS = 365;

export const IDLE_PERIODS = ["0,5", "6,10", "11,15", "16,20", "21,25", "26,30", `31,${MAX_IDLE_DAYS}`];

// First day of the last range
export const LAST_PERIOD_MIN = Number(IDLE_PERIODS[IDLE_PERIODS.length - 1].split(",")[0]);

// The dashboard filters, as every idle repairs endpoint takes them ("" means not filtered)
export const EMPTY_IDLE_FILTERS = Object.freeze({
  status_id: "",
  period: "",
  days: "",
  date_from: "",
  date_to: "",
  asf: ""
});
